import { Component, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { LoadingService } from 'src/app/modules/shared/services/loading.service';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.css']
})

export class LoadingComponent implements OnDestroy {

  /**
   * @var Subscription
   */
  private loadingSub: Subscription;

  constructor(
    private spinner: NgxSpinnerService, private loading: LoadingService
  ) {
    this.loadingSub = this.loading.getLoadingState()
      .subscribe(this.updateLoading);
  }

  /**
   * Entfernt die vorhandene Subscription
   */
  ngOnDestroy () {
    this.loadingSub.unsubscribe();
  }

  /**
   * Aktualisiert den LoadingStatus
   *
   * @param loading
   */
  public updateLoading = (loading: boolean) => {
    if (loading) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }

}
